import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';


export default function PasswordModal({
    newPass,
    handleNewPassChange,
    handlePassChange,
    pass
}) {

    const { patient } = useSelector((state) => state.user)

  return (
    <Modal
    style={{
      content: { ...styles.centerModal },
    }}
    isOpen={pass}
    onRequestClose={() =>handlePassChange(false)}
    contentLabel="Example Modal"
  >
    <div style={styles.container}>

      <AiOutlineCloseCircle style={styles.closeButton} onClick={ ()=>handlePassChange(false)} />

      <div style={styles.passTitle}> Please set new password:</div>
      <div style={styles.insideContainer}>
        <dt>new password :</dt>
        <dd>
          <input value={newPass} onChange={(e) => handleNewPassChange(e.target.value)} />
        </dd>
        <div
          onClick={() => {
            this.props.setNewPass(patient.personalInfo.id, newPass);
            this.getDetails();
          }}
          style={{ ...styles.button, marginTop: 5 }}
        >
          Set new pass
        </div>
      </div>
    </div>
  </Modal>
  )
}
const styles = {
    insideContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    passTitle: {
        position: 'relative',
        top: -20,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 40,
    },
    closeButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '30px',
        height: '30px',
        cursor: 'pointer',
    },

    centerModal: {
        width: 600,
        height: 600,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    container: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    }
}